export default "__VITE_ASSET__449d87af__"